import { CombinedState, combineReducers } from "redux";
import {
  preferenceActions,
  PreferenceData,
  toastActions,
  ToastData,
  userActions,
  UserData,
} from "../types";
import toastReducer from "./toast";
import userReducer from "./user";
import preferenceReducer from "./preference";
import { candidatesComparisonReducer } from "./candidatesComparison";
import { CandidatesComparisonState } from "state/types/candidatesComparison";
import assessmentReducer from "./assessment";
import { AssessmentState } from "state/types/assessment";

const allReducers = combineReducers({
  toast: toastReducer,
  user: userReducer,
  preference: preferenceReducer,
  candidatesComparison: candidatesComparisonReducer,
  assessment: assessmentReducer,
});
export type RootReducerState =
  | CombinedState<{
      toast: ToastData;
      user: UserData;
      preference: PreferenceData;
      candidatesComparison: CandidatesComparisonState;
      assessment: AssessmentState;
    }>
  | undefined;

export type RootReducerAction =
  | CombinedState<{
      toast: toastActions;
      user: userActions;
      preference: preferenceActions;
    }>
  | any;

const rootReducer = (state: RootReducerState, action: RootReducerAction) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return allReducers(state, action);
};

export { rootReducer };
